import { CountryCode } from '@dixa/lib-shared-habla';

/**
 * Gets the country name from a country code.
 *
 * @param countryCode The country code.
 */
export function getCountryNameFromCountryCode(
  countryCode: CountryCode,
): string {
  try {
    return (
      new Intl.DisplayNames(['en'], { type: 'region' }).of(
        countryCode.toUpperCase(),
      ) ?? countryCode
    );
  } catch (error) {
    return countryCode;
  }
}
